module.exports = {
  "country": "AT",
  "artist": "Zoe",
  "song": "Loin d'ici",
  "year": "2016",
  "place": "13",
  "spotify": "3BRBtijNjtOO9MrQnYATgT"
};